// Application Constants

export const APP_NAME = 'UniversalTrustCU'
export const APP_VERSION = '2.0.0'
export const APP_TAGLINE = 'Banking Built on Trust'

// Transaction Types
export const TRANSACTION_TYPES = {
  DEPOSIT: 'deposit',
  WITHDRAWAL: 'withdrawal',
  TRANSFER_IN: 'transfer_in',
  TRANSFER_OUT: 'transfer_out',
  ADMIN_ADJUSTMENT: 'admin_adjustment'
}

// Transaction Status
export const TRANSACTION_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  COMPLETED: 'completed'
}

// User Roles
export const USER_ROLES = {
  USER: 'user',
  ADMIN: 'admin'
}

// Account Status
export const ACCOUNT_STATUS = {
  ACTIVE: 'active',
  SUSPENDED: 'suspended',
  CLOSED: 'closed'
}

// Notification Types
export const NOTIFICATION_TYPES = {
  TRANSACTION_APPROVED: 'transaction_approved',
  TRANSACTION_REJECTED: 'transaction_rejected',
  TRANSFER_RECEIVED: 'transfer_received',
  TRANSFER_SENT: 'transfer_sent',
  ACCOUNT_UPDATE: 'account_update',
  SECURITY_ALERT: 'security_alert'
}

// Activity Actions
export const ACTIVITY_ACTIONS = {
  LOGIN: 'login',
  LOGOUT: 'logout',
  REGISTER: 'register',
  DEPOSIT_REQUEST: 'deposit_request',
  WITHDRAWAL_REQUEST: 'withdrawal_request',
  TRANSFER_REQUEST: 'transfer_request',
  PROFILE_UPDATE: 'profile_update',
  PASSWORD_CHANGE: 'password_change',
  ADMIN_APPROVE: 'admin_approve',
  ADMIN_REJECT: 'admin_reject',
  ADMIN_UPDATE_USER: 'admin_update_user',
  ADMIN_DELETE_USER: 'admin_delete_user'
}

// Validation
export const VALIDATION = {
  MIN_PASSWORD_LENGTH: 8,
  MAX_PASSWORD_LENGTH: 50,
  MIN_USERNAME_LENGTH: 3,
  MAX_USERNAME_LENGTH: 30,
  MIN_TRANSACTION_AMOUNT: 1,
  MAX_TRANSACTION_AMOUNT: 1000000,
  USERNAME_REGEX: /^[a-zA-Z0-9_-]+$/,
  PHONE_REGEX: /^[+]?[(]?[0-9]{1,4}[)]?[-\s.]?[(]?[0-9]{1,4}[)]?[-\s.]?[0-9]{1,9}$/
}

// Date Formats
export const DATE_FORMATS = {
  FULL: 'PPpp',
  DATE_ONLY: 'PP',
  TIME_ONLY: 'p',
  SHORT: 'MM/dd/yyyy',
  ISO: "yyyy-MM-dd'T'HH:mm:ss"
}

// Currency
export const CURRENCY = {
  SYMBOL: '$',
  CODE: 'USD',
  LOCALE: 'en-US'
}

// Pagination
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 20,
  PAGE_SIZE_OPTIONS: [10, 20, 50, 100]
}

// Theme
export const THEMES = {
  LIGHT: 'light',
  DARK: 'dark'
}

// Local Storage Keys
export const STORAGE_KEYS = {
  THEME: 'securebank_theme',
  USER_PREFERENCES: 'securebank_preferences'
}

// API Endpoints (if using separate backend)
export const API_ENDPOINTS = {
  AUTH: '/api/auth',
  USERS: '/api/users',
  TRANSACTIONS: '/api/transactions',
  TRANSFERS: '/api/transfers',
  ADMIN: '/api/admin'
}

// Chart Colors
export const CHART_COLORS = {
  PRIMARY: '#0ea5e9',
  SUCCESS: '#10b981',
  WARNING: '#f59e0b',
  DANGER: '#ef4444',
  INFO: '#6366f1',
  GRAY: '#64748b'
}

// File Export
export const EXPORT_FORMATS = {
  PDF: 'pdf',
  CSV: 'csv',
  EXCEL: 'xlsx'
}

// Refresh Intervals (milliseconds)
export const REFRESH_INTERVALS = {
  DASHBOARD: 30000, // 30 seconds
  TRANSACTIONS: 15000, // 15 seconds
  NOTIFICATIONS: 10000, // 10 seconds
  PENDING_APPROVALS: 5000 // 5 seconds
}

// Error Messages
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Network error. Please check your connection.',
  UNAUTHORIZED: 'You are not authorized to perform this action.',
  SESSION_EXPIRED: 'Your session has expired. Please login again.',
  INVALID_INPUT: 'Please check your input and try again.',
  SERVER_ERROR: 'Server error. Please try again later.',
  INSUFFICIENT_FUNDS: 'Insufficient funds for this transaction.',
  USER_NOT_FOUND: 'User not found.',
  TRANSACTION_FAILED: 'Transaction failed. Please try again.'
}

// Success Messages
export const SUCCESS_MESSAGES = {
  LOGIN: 'Login successful!',
  LOGOUT: 'Logged out successfully.',
  REGISTER: 'Account created successfully!',
  DEPOSIT_REQUEST: 'Deposit request submitted. Awaiting approval.',
  WITHDRAWAL_REQUEST: 'Withdrawal request submitted. Awaiting approval.',
  TRANSFER_SUCCESS: 'Transfer successful!',
  PROFILE_UPDATE: 'Profile updated successfully.',
  PASSWORD_CHANGE: 'Password changed successfully.',
  TRANSACTION_APPROVED: 'Transaction approved successfully.',
  TRANSACTION_REJECTED: 'Transaction rejected.'
}

export default {
  APP_NAME,
  APP_VERSION,
  TRANSACTION_TYPES,
  TRANSACTION_STATUS,
  USER_ROLES,
  ACCOUNT_STATUS,
  NOTIFICATION_TYPES,
  ACTIVITY_ACTIONS,
  VALIDATION,
  DATE_FORMATS,
  CURRENCY,
  PAGINATION,
  THEMES,
  STORAGE_KEYS,
  API_ENDPOINTS,
  CHART_COLORS,
  EXPORT_FORMATS,
  REFRESH_INTERVALS,
  ERROR_MESSAGES,
  SUCCESS_MESSAGES
}